import { jsx as n } from "react/jsx-runtime";
import { Children as t, isValidElement as i, cloneElement as p } from "react";
import "@tameeni/shared-logic";
import "@tameeni/icons";
import "@tameeni/ui";
function d({ locale: e, currentActiveTab: o, children: m }) {
  return /* @__PURE__ */ n("div", { className: "overflow-hidden", children: t.map(m, (r) => i(r) ? p(r, {
    ...r.props,
    locale: e,
    currentActiveTab: o
  }) : null) });
}
export {
  d as Home
};
//# sourceMappingURL=home.js.map
